/**
 * Today's hours component used on the front page. 
 */
import React from 'react';
import { useEffect, useState } from 'react';
import Notice from './notice';
// import * as styles from 'src/uglib_styles/buildingHoursNotice.module.css'

function BuildingHoursNotice (props) {
	
	let [hours, setHours] = useState('8am - 10pm');

	useEffect(() => {
		const hours_api = 'https://api3-ca.libcal.com/api_hours_today.php?iid=3228&format=json';
		fetch(hours_api)
		.then(response => response.json())
		.then(result => {
			let locations = result.locations;

			locations.forEach(location => {
				if (location.lid === 1911) {
					const open_hours = location.rendered;
					setHours(open_hours);
				}
			});			
		});

	}, [hours]);

	return (<>
		<Notice icon="fa-clock" color="var(--uglib-grey)" >
			<span>Today's Hours: {hours} - </span>
			<span>
                <a href="/service-hours">All service hours</a>
            </span>
		</Notice>		
	</>)
}

export default BuildingHoursNotice